import { FC } from 'react';

import { Button, theme, Typography } from '@/shared/design-system';

import { formatMemberCount } from '../../role-descriptions';
import { SaveBarActions, SaveBarRoot, SaveBarText } from './styled';

export const REVIEW_CHANGES_LABEL = 'Review changes';
export const DISCARD_CHANGES_LABEL = 'Discard';

export type DraftSaveBarProps = {
  added: number;
  removed: number;
  memberCount: number;
  disabled?: boolean;
  onDiscard: () => void;
  onReview: () => void;
};

export const formatUnsavedChanges = (count: number) =>
  `${count} unsaved change${count === 1 ? '' : 's'}`;

export const formatDraftImpact = (added: number, removed: number, memberCount: number) => {
  const parts = [added ? `+${added} added` : null, removed ? `−${removed} removed` : null].filter(
    Boolean,
  );

  return `${parts.join(' · ')} · affects ${formatMemberCount(memberCount)}`;
};

export const DraftSaveBar: FC<DraftSaveBarProps> = ({
  added,
  removed,
  memberCount,
  disabled,
  onDiscard,
  onReview,
}) => (
  <SaveBarRoot role="region" aria-label="Unsaved permission changes">
    <SaveBarText>
      <Typography variant="body3" fontWeight={600} color={theme.colors.text.primary}>
        {formatUnsavedChanges(added + removed)}
      </Typography>
      <Typography variant="body4" color={theme.colors.text.secondary}>
        {formatDraftImpact(added, removed, memberCount)}
      </Typography>
    </SaveBarText>

    <SaveBarActions>
      <Button size="sm" variant="ghost" color="tertiary" disabled={disabled} onClick={onDiscard}>
        {DISCARD_CHANGES_LABEL}
      </Button>
      <Button size="sm" disabled={disabled} onClick={onReview}>
        {REVIEW_CHANGES_LABEL}
      </Button>
    </SaveBarActions>
  </SaveBarRoot>
);
